import { createAction } from "redux-actions";

export const setPlatforms = createAction("SET_PLATFORMS");
export const getPlatforms = createAction("GET_PLATFORMS");
